import { render, staticRenderFns } from "./CzLink.vue?vue&type=template&id=310862fe&scoped=true&"
import script from "./CzLink.vue?vue&type=script&lang=ts&"
export * from "./CzLink.vue?vue&type=script&lang=ts&"
import style0 from "./CzLink.vue?vue&type=style&index=0&id=310862fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310862fe",
  null
  
)

export default component.exports